import React from 'react';
import { 
  FiBarChart2, FiBell, FiCreditCard, FiDollarSign, FiFileText, FiFolder, 
  FiHome, FiKey, FiLogOut, FiTarget, FiTool, FiUserCheck, FiUsers, 
  FiVolume2, FiShield, FiSmartphone, FiMessageSquare, FiX
} from 'react-icons/fi';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
  
const Sidebar = ({ isOpen, onClose }) => {  
  const { user, logout } = useAuth();  
  const role = user?.role_slug || user?.role || '';  
  const isSuperAdmin = role === 'super-admin';
  const isAdmin = ['super-admin', 'admin-agence'].includes(role);  
  const isComptable = role === 'comptable';  
  const isLocataire = role === 'locataire';  
  const isClient = role === 'client';  
  const isPrestataire = role === 'prestataire';  
  
  const navItems = [  
    { section: 'Principal' },  
    { path: '/dashboard', label: 'Tableau de bord', icon: FiHome },  
  ];  

  // Super Admin section
  if (isSuperAdmin) {
    navItems.push({ section: 'Super Administration' });
    navItems.push({ path: '/admin/dashboard', label: 'Super Dashboard', icon: FiShield });
    navItems.push({ path: '/admin/agencies', label: 'Agences & Locataires', icon: FiHome });
    navItems.push({ path: '/admin/sms-pack-plans', label: 'Grilles Tarifaires SMS', icon: FiDollarSign });
    navItems.push({ path: '/admin/sms-orders', label: 'Demandes Achat SMS', icon: FiMessageSquare });
    navItems.push({ path: '/admin/sms-logs', label: 'Logs SMS Plateforme', icon: FiVolume2 });
  }
  
  if (!isLocataire && !isClient && !isPrestataire) {  
    navItems.push({ section: 'Immobilier & Ventes' });  
    navItems.push({ path: '/properties', label: 'Biens', icon: FiKey });  
    navItems.push({ path: '/sales', label: 'Ventes & Achats', icon: FiDollarSign });  
    navItems.push({ path: '/announcements', label: 'Annonces', icon: FiVolume2 });  
  }  
  if (isClient) {  
    navItems.push({ section: 'Annonces' });  
    navItems.push({ path: '/announcements', label: 'Annonces', icon: FiVolume2 }); 
    navItems.push({ path: '/mandates', label: 'Mandats', icon: FiFileText });
  }  
  if (!isLocataire && !isClient && !isPrestataire && !isComptable) {  
    navItems.push({ section: 'CRM' });  
    navItems.push({ path: '/clients', label: 'Clients', icon: FiUsers });  
    navItems.push({ path: '/leads', label: 'Leads', icon: FiTarget });  
  }  
  if (!isClient && !isPrestataire) {  
    navItems.push({ section: 'Gestion Locative' });  
    if (!isLocataire) navItems.push({ path: '/tenants', label: 'Locataires', icon: FiUserCheck });  
    navItems.push({ path: '/leases', label: 'Contrats', icon: FiFileText }); 
    navItems.push({ path: '/mandates', label: 'Mandats', icon: FiFileText });
    navItems.push({ path: '/inventories', label: 'États des lieux', icon: FiFileText });
    if (!isLocataire) navItems.push({ path: '/litigations', label: 'Contentieux & Litiges', icon: FiFileText });
  }  
  if (!isLocataire && !isClient && !isPrestataire) {  
    navItems.push({ section: 'Finance' });  
    navItems.push({ path: '/invoices', label: 'Factures', icon: FiDollarSign });  
    navItems.push({ path: '/payments', label: 'Paiements & Relances', icon: FiCreditCard });  
    navItems.push({ path: '/expenses', label: 'Dépenses & Charges', icon: FiDollarSign });  
    navItems.push({ path: '/agency/sms-packs', label: 'Recharge Crédits SMS', icon: FiSmartphone });  
    navItems.push({ path: '/payment-intents', label: 'Intentions', icon: FiDollarSign });  
    navItems.push({ path: '/agency-payment-methods', label: 'Méthodes de paiement', icon: FiCreditCard });  
  }  
  if ((isLocataire || isComptable) && !navItems.find(i => i.path === '/payments')) {  
    navItems.push({ section: 'Finance' });  
    navItems.push({ path: '/payments', label: 'Paiements & Relances', icon: FiCreditCard });  
    if (isComptable) {
      navItems.push({ path: '/expenses', label: 'Dépenses & Charges', icon: FiDollarSign });
      navItems.push({ path: '/agency/sms-packs', label: 'Recharge Crédits SMS', icon: FiSmartphone });
    }
  }  
  navItems.push({ section: 'Opérations' });  
  navItems.push({ path: '/maintenance', label: 'Maintenance', icon: FiTool });  
  if (!isClient && !isPrestataire) {  
    navItems.push({ path: '/documents', label: 'Documents', icon: FiFolder });  
  }  
  navItems.push({ path: '/notifications', label: 'Notifications', icon: FiBell });  
  if (isAdmin && !isSuperAdmin) {  
    navItems.push({ section: 'Administration' });  
    navItems.push({ path: '/agency', label: 'Mon Agence', icon: FiHome });  
    navItems.push({ path: '/users', label: 'Utilisateurs', icon: FiUsers });  
  }  
  if (isAdmin || isComptable) {  
    navItems.push({ section: 'Reporting' });  
    navItems.push({ path: '/reports', label: 'Rapports', icon: FiBarChart2 });  
  }  
  
  return (  
    <>
      {/* Backdrop sombre pour fermeture sur mobile */}
      <div 
        className={`sidebar-backdrop ${isOpen ? 'show' : ''}`} 
        onClick={onClose} 
        aria-hidden="true" 
      />

      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>  
        <div className="sidebar-logo">  
          <div className="sidebar-logo-brand">
            <FiKey size={22} style={{ color: 'var(--primary-light, #93c5fd)' }} />  
            <span>GestionImmo</span>  
          </div>
          {onClose && (
            <button 
              type="button"
              className="sidebar-mobile-close" 
              onClick={onClose}
              aria-label="Fermer le menu"
            >
              <FiX size={18} />
            </button>
          )}
        </div>  

        <nav className="sidebar-nav">  
          {navItems.map((item, idx) =>  
            item.section ? (  
              <div key={idx} className="sidebar-section">{item.section}</div>  
            ) : (  
              <NavLink 
                key={idx} 
                to={item.path} 
                onClick={onClose}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              >  
                <span className="icon"><item.icon /></span>  
                <span>{item.label}</span>  
              </NavLink>  
            )  
          )}  
        </nav>  

        <div className="sidebar-user">  
          <div className="avatar">
            {user?.first_name?.[0] || 'U'}{user?.last_name?.[0] || ''}
          </div>  
          <div className="info">  
            <div className="name">{user?.first_name} {user?.last_name}</div>  
            <div className="role">{user?.role_name || user?.role}</div>  
          </div>  
          <button className="topbar-btn" onClick={logout} title="Déconnexion" style={{ color: 'rgba(255,255,255,0.8)' }}>
            <FiLogOut />
          </button>  
        </div>  
      </aside>  
    </>
  );  
};  
  
export default Sidebar;
